import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "../../../components/ui/card";
import { AlertCircle, CheckCircle, CreditCard } from "lucide-react";
import confirm from "../../../components/DialogComponent/confirm";
import { Container } from "@material-ui/core";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useMediaQuery } from "@mui/material";

const YourPayments = () => {
  const [isConnected, setIsConnected] = useState(false);
  const isMobile = useMediaQuery("(max-width:767px)");

  const accountData = {
    companyName: "Acme Corporation LLC",
    bankName: "Chase Bank",
    accountLast4: "1234",
  };

  const handleConnect = () => {
    window.location.href = `https://connect.stripe.com/oauth/authorize?response_type=code&client_id=ca_SeZW9nSK0lRWPCpS6gOZxmLEUchLfjTk&scope=read_write`;
  };

  const handleDisconnect = () => {
    confirm(
      "Are you sure you want to disconnect your Stripe account? You will no longer be able to receive payments."
    )
      .then(() => {
        setIsConnected(false);
      })
      .catch(() => {
        console.log("Cancel clicked!");
      });
  };

  return (
    <Container>
      <PageTitle
        pageTitle={`Your Payments`}
        showBreadcrumb={[
          { label: "Home", to: "/" },
          { label: "Settings", to: "/account/settings" },
        ]}
        BreadCrumbCurrentPageTitle={"Payments"}
        showLastSeen={true}
      />
      <div className="ph-32 pv-24 ">
        <div
          className="space-y-6 "
          style={{ maxWidth: isMobile ? "390px " : "1080px", margin: "0 auto" }}
        >
          <Card className="dark:border-0 dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
            <CardHeader className="p-24">
              <div className="flex items-center space-x-2">
                <CreditCard className="h-5 w-5 text-primary" />
                <CardTitle>Your Payments</CardTitle>
              </div>
              <CardDescription>
                Setup & receive payments directly to your bank account
              </CardDescription>
            </CardHeader>
            <CardContent className="pb-24 ph-24 pt-0">
              {isConnected ? (
                <>
                  <div className="flex items-start space-x-4 p-16 border rounded-lg bg-green-50 dark:bg-green-950/20 border-green-200 dark:border-green-800">
                    <div className="h-12 w-12 rounded-lg bg-green-100 dark:bg-green-900/50 flex items-center justify-center">
                      <CheckCircle className="h-6 w-6 text-green-600 dark:text-green-400" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <div className="flex items-center space-x-2">
                        <h3 className="font-semibold text-green-900 dark:text-green-100">
                          Stripe Connected Successfully
                        </h3>
                      </div>
                      <p className="text-sm text-green-700 dark:text-green-300">
                        Your account is connected and ready to receive payments.
                      </p>
                    </div>
                  </div>

                  <div className="border rounded-lg p-24 bg-background">
                    <div className="flex items-center justify-between mb-6">
                      <div>
                        <h3 className="font-semibold text-lg">
                          Connected Account Details
                        </h3>
                        <p className="text-sm text-muted-foreground mt-1">
                          Your Stripe account information
                        </p>
                      </div>
                      <div className="h-8 w-20 bg-primary/20 rounded flex items-center justify-center">
                        <span className="text-xs font-medium text-primary">
                          STRIPE
                        </span>
                      </div>
                    </div>

                    <div className="space-y-4">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-muted-foreground">
                              Company Name
                            </label>
                            <p className="text-sm font-semibold">
                              {accountData.companyName}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-muted-foreground">
                              Bank
                            </label>
                            <p className="text-sm font-semibold">
                              {accountData.bankName}
                            </p>
                          </div>
                        </div>
                        <div className="space-y-3">
                          <div>
                            <label className="text-sm font-medium text-muted-foreground">
                              Account Number
                            </label>
                            <p className="text-sm font-semibold">
                              ****{accountData.accountLast4}
                            </p>
                          </div>
                          <div>
                            <label className="text-sm font-medium text-muted-foreground">
                              Status
                            </label>
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span className="text-sm font-semibold text-green-600 dark:text-green-400">
                                Active
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="pt-16 border-t space-y-3">
                        <button
                          onClick={handleDisconnect}
                          className="w-full bg-destructive hover:bg-destructive/90 text-destructive-foreground py-3 px-6 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2"
                        >
                          <AlertCircle className="h-4 w-4" />
                          <span>Disconnect Stripe Account</span>
                        </button>
                        <p className="text-xs text-muted-foreground text-center">
                          You will no longer be able to receive payments after
                          disconnecting
                        </p>
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <>
                  <div className="flex items-start space-x-4 p-16 border rounded-lg bg-background dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0">
                    <div className="h-12 w-12 rounded-lg bg-primary/10 flex items-center justify-center">
                      <CreditCard className="h-6 w-6 text-primary" />
                    </div>
                    <div className="flex-1 space-y-2">
                      <h3 className="font-semibold">Connect with Stripe</h3>
                      <p className="text-sm text-muted-foreground">
                        Start accepting payments by connecting your Stripe
                        account. Stripe handles all payment processing,
                        security, and compliance.
                      </p>
                      <ul className="text-sm text-muted-foreground space-y-1">
                        <li>
                          • Accept credit cards, debit cards, and digital
                          wallets
                        </li>
                        <li>• Get paid directly to your bank account</li>
                        <li>
                          • Industry-leading security and fraud protection
                        </li>
                        <li>• Automatic tax calculation and reporting</li>
                      </ul>
                    </div>
                  </div>
                  <div className="dark:bg-[#1A1F2C] dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] dark:border-0">
                    <div className="border rounded-lg p-24 mt-24 bg-gradient-to-r from-blue-50 to-indigo-50 dark:bg-none dark:border-0">
                      <div className="flex items-center justify-between mb-16">
                        <div>
                          <h3 className="font-semibold text-lg">
                            Stripe Standard Connect
                          </h3>
                          <p className="text-sm text-muted-foreground mt-4">
                            The fastest way to start accepting payments
                          </p>
                        </div>
                        <div className="h-8 w-20 bg-primary/20 rounded flex items-center justify-center">
                          <span className="text-xs font-medium text-primary">
                            STRIPE
                          </span>
                        </div>
                      </div>

                      <div className="space-y-4">
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm">
                          <div className="space-y-2">
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>2.9% + 30¢ per transaction</span>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>No monthly fees</span>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>7-day rolling payouts</span>
                            </div>
                          </div>
                          <div className="space-y-2">
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>Global payment methods</span>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>Real-time reporting</span>
                            </div>
                            <div className="flex items-center space-x-2">
                              <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                              <span>24/7 support</span>
                            </div>
                          </div>
                        </div>

                        <div className="pt-4 border-t">
                          <button
                            onClick={handleConnect}
                            className="w-full bg-primary hover:bg-primary/90 text-primary-foreground py-3 px-6 rounded-lg font-medium transition-colors flex items-center justify-center space-x-2"
                          >
                            <span>Connect with Stripe</span>
                            <svg
                              className="h-4 w-4"
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth={2}
                                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
                              />
                            </svg>
                          </button>
                          <p className="text-xs text-muted-foreground text-center mt-8">
                            You'll be redirected to Stripe to create or connect
                            your account
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="text-center ">
                    <p className="text-sm text-muted-foreground mt-20">
                      Need help getting started?
                      <a
                        href="https://stripe.com/docs/connect"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-primary hover:underline ml-4"
                      >
                        View Stripe Connect documentation
                      </a>
                    </p>
                  </div>
                </>
              )}
            </CardContent>
          </Card>
        </div>
      </div>
    </Container>
  );
};

export default YourPayments;
